/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { GenericCardContainerProps } from './types';
import Container from './Container';

export const ContainerAnalytics = withAnalytics(Container);

/**
 * UI Toolkit Generic Card component based on Veneer Card
 * @public
 */

const TGenericCard: React.FC<GenericCardContainerProps> = (props) => {
  const { id, children, onClick, bgColor, trackId, ...rest } = props;
  if (trackId) {
    return (
      <ContainerAnalytics
        {...{
          id,
          onClick,
          children,
          bgColor,
          trackId,
          ...rest
        }}
      />
    );
  }
  return (
    <Container
      {...{
        id,
        onClick,
        children,
        bgColor
      }}
    />
  );
};

export default memo(TGenericCard);
